<template>
  <div class="player-detail">
    <PlayerTopImg :player-num="playerInfo.player_no" :player-img="playerInfo.id_img" />

    <ul class="player-name-text">
      <li class="positions">
        <span>{{playerInfo.position}}</span>
      </li>
      <li class="name">{{playerInfo.k_name}}</li>
      <li>{{playerInfo.e_name}}</li>
    </ul>

    <ul class="player-info-text">
      <li>
        <p class="sub">포지션</p>
        <p class="title">{{playerInfo.k_position}}</p>
      </li>
      <li class="line"></li>
      <li>
        <p class="sub">생년월일</p>
        <p class="title">{{playerInfo.birth_year}}년</p>
        <p class="title">{{ playerInfo.birth_date }}</p>
      </li>
      <li class="line"></li>
      <li>
        <p class="sub">신체정보</p>
        <p class="title">{{playerInfo.tall}}cm</p>
        <p class="title">{{playerInfo.weight}}kg</p>
      </li>
      <li class="line"></li>
      <li>
        <p class="sub">출신</p>
        <p class="title">{{ playerInfo.nation }}</p>
      </li>
    </ul>

    <div class="tab-box-line">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
            @click="tabIndexChange(currentTab)">
          <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
        </li>
      </ul>
    </div>

    <div v-if="currentTab === 0" class="tab-content">
      <TotalYearlyRecords :total="playerTotalInfo" :season="playerSeasonInfo" />
    </div>
    <div v-if="currentTab === 1" class="tab-content">
      <MatchHistory />
    </div>
  </div>
</template>

<script>
import PlayerTopImg from '@/components/Player/PlayerTopImg.vue';
import TotalYearlyRecords from '@/components/Player/TotalYearlyRecords.vue';
import MatchHistory from '@/components/Player/MatchHistory.vue';
import dayjs from "dayjs";
import player from "../Main/Player.vue";

export default {
  name: 'PlayerDetail',
  computed: {
    player() {
      return player
    }
  },
  components: {MatchHistory, TotalYearlyRecords, PlayerTopImg},
  data() {
    return {
      currentTab: 0,
      tabList: ['통산/연도별 기록', '경기별 기록'],
      playerInfo: {},
      playerTotalInfo: {},
      playerSeasonInfo: []
    }
  },
  mounted () {
    this.getPlayerInfo()
  },
  methods: {
    tabIndexChange(val) {
    },
    async getPlayerInfo() {

      const {data} = await this.$http.get(`/player/total?player_id=${this.$route.params.id}`);
      // console.log(data);
      if(data.success) {
        this.playerInfo = data.data;
        this.playerTotalInfo = data.data.total[0];
        this.playerSeasonInfo = data.data.season;

        this.playerInfo.k_position = this.getKoPosition(this.playerInfo.position);
        this.playerInfo.birth_year = dayjs(this.playerInfo.birthday).format('YYYY');
        this.playerInfo.birth_date = dayjs(this.playerInfo.birthday).format('MM월 DD일');
        this.playerInfo.birth_month = dayjs(this.playerInfo.birthday).format('MM');
        this.playerInfo.birth_day = dayjs(this.playerInfo.birthday).format('DD');
      }

      let obj = {
        koNm: '발디비아',
        engNm: 'Wanderson Ferreira De Oliveira',
        koPosition: '공격수',
        engPosition: 'FW',
        birthday: '1994-10-04',
        height: '174',
        weight: '70',
        ancestry: '브라질',
        number: '10'
      };

    },
    getKoPosition(pos) {
      if(pos === 'GK') {
        return '골키퍼';
      } else if(pos === 'DF') {
        return '수비수';
      } else if(pos === 'MF') {
        return '미드필더';
      } else if(pos === 'FW') {
        return '공격수';
      }
    }
  }
}
</script>
